import React, { useEffect, useState } from 'react';
import ChooseProduct from './ChooseProduct';
import FormBlock from '../../../../components/Form/FormBlock';
import i18n from '../../../../i18n';

const ProductReservation = ({product_id}) => {
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
    const [product, setProduct] = useState(product_id)
    const startFormUrl = product_id ? '/rest/productlisting/'+product_id+'/select_availability/?date=' + selectedDate.toISOString().split('T')[0] : null
    const [formUrl, setFormUrl] = useState(startFormUrl)
    const [dateChangeTimeout, setDateChangeTimeout] = useState(null);

    const handleDateChange = (date) => {
        if (dateChangeTimeout) {
            clearTimeout(dateChangeTimeout);
        }
        const timeoutId = setTimeout(() => {
            setSelectedDate(new Date(date));
        }, 400);
        setDateChangeTimeout(timeoutId);
    };

    useEffect( () => {
        product && setFormUrl('/rest/productlisting/'+product+'/select_availability/?date=' + selectedDate.toISOString().split('T')[0])
    }, [product, selectedDate])

    return (
    <div className='container '>
        <h5>{i18n.t('Reserveren')}</h5>
        <div className='row'>
            {(!product_id) &&
                <div className='col-12 col-md-6'>
                    <ChooseProduct chosenProduct={product} setProduct={setProduct} />
                </div>
            }
            <div className='col-12 col-md-6'>
                <input className='form-control' style={{width:'fit-content'}} type="date" defaultValue={selectedDate.toISOString().split('T')[0]} onChange={(e) => handleDateChange(e.target.value)} />
            </div>
        </div>
        {formUrl &&
        <>
            <h6 className='mt-2 mb-0 col-12'>{i18n.t('Gekozen datum')}: {selectedDate.toLocaleDateString()}</h6>
            <FormBlock className='col-12' url={formUrl} />
        </>
        }
    </div>
    );
};


export default ProductReservation